'use client';

import { cn } from '@/lib/utils';

export function PriceActivitySkeleton() {
  return (
    <div className="space-y-4" aria-busy aria-label="A carregar alterações">
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={`sum-${i}`}
            className="h-[58px] animate-pulse rounded-xl border border-white/[0.06] bg-white/[0.04]"
          />
        ))}
      </div>
      <div className="flex gap-1.5">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={`chip-${i}`}
            className="h-8 w-24 animate-pulse rounded-full border border-white/[0.06] bg-white/[0.04]"
          />
        ))}
      </div>
      <div className="space-y-2.5">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={`row-${i}`}
            className={cn(
              'h-[88px] animate-pulse rounded-xl border border-white/[0.06] bg-white/[0.04]',
              i > 1 && 'opacity-70',
              i > 2 && 'opacity-45'
            )}
          />
        ))}
      </div>
    </div>
  );
}
